import { Video, VideoStatus } from 'data/Video'

export const isLiveStreamUnknown = (video: Video) => video.status === VideoStatus.UNKNOWN
export const isLiveStreamActive = (video: Video) => video.status === VideoStatus.ACTIVE
export const isLiveStreamIdle = (video: Video) => video.status === VideoStatus.IDLE
export const hasLiveStreamErrors = (video: Video) => video.status === VideoStatus.ERROR
